<div class="bg-white background">
</div>
<app-menu-template2>
  <main class="container-fluid">
    <header class="row bg-header">
      <div class="col-2 m-auto">
        <img class="col-sm-12 p-0 mt-4 ml-3" src="../../../../../assets/images/legislacion-01.png" />
      </div>
      <div class="col-10 m-auto">
        <p class="m-0 ml-4">Registro Nacional de Turismo</p>
        <h1 class="m-0 font-weight-bold ml-4">Legislación</h1>
      </div>
    </header>
    <article class="row bg-white">
      <section class="p-5 m-auto w-75">
        <ul class="list-group">
          <li *ngFor="let item of legislacion" class="list-group-item d-flex justify-content-between align-items-center border-right-0 border-left-0 p-3">
            <header>
              <h2 class="font-weight-bold m-0 h5" [innerHTML]="item.titulo"></h2>
              <p [innerHTML]="item.descripcion"></p>
            </header>
            <div>
              <img (click)="onSaveFile(item)" class="pointer" width="27" height="27" src="../../../../../assets/icons/doc.png" />
            </div>
          </li>
        </ul>
      </section>
    </article>
  </main>
</app-menu-template2>
